import DOMPurify from 'dompurify';

// Defense-in-depth sanitizer for HTML produced by the TipTap editor. Anything
// outside the allowlist is stripped — keeps the public career page safe even
// if a recruiter pastes a screen reader trap or an external embed.
const ALLOWED_TAGS = [
  'p', 'br', 'strong', 'em', 'b', 'i', 'u',
  'ul', 'ol', 'li',
  'h2', 'h3',
  'a', 'span',
];
const ALLOWED_ATTR = ['href', 'target', 'rel'];

export function sanitizeHtml(html) {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ADD_ATTR: ['target'],
  });
}
